import React, { Component } from "react";
import UserSettingsHolder from "./Styles/userSettingsComponentStyle";
import {
  Form,
  Input,
  Icon,
  Button,
  Modal,
  Card,
  Avatar,
  Table,
  Upload,
  notification
} from "antd";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';
import Colors from '../themes/Colors';
import AccountLayout from '../newSrc/layouts/AccountLayout/AccountLayout';
import VerifiedCheck from './customComponents/VerifiedCheck/VerifiedCheck';
import ListPagination, { getPageItems, getLastPage } from '../newSrc/shared/components/ListPagination';

const MAX_AVATAR_SIZE_BYTES = 2 * 1024 * 1024;
const CLIENTS_PAGE_SIZE = 20;

class UserSettingsComponent extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    mailModalVisible: false,
    passwordModalVisible: false,
    lastFormSubmitted: "",
    clientsPage: 1,
    errors: {}
  };

  changeClientsPage = page => {
    this.setState({ clientsPage: page });
  };

  componentDidMount() {
    if (!this.props.user) {
      this.props.setShouldPromptLogin(true, window.location.pathname);
      return;
    }

    if (this.isAgency()) {
      this.props.getUserClients(this.props.user.id);
    }
  }

  isAgency = () => {
    const { user } = this.props;
    return !!(user && user.company && user.company.type === "agency");
  };

  showMailModal = () => {
    this.setState({
      mailModalVisible: true
    });
  };

  handleOkMailModal = () => {
    this.setState({
      mailModalVisible: false
    });
  };

  handleCancelMailModal = () => {
    this.setState({
      mailModalVisible: false
    });
  };

  showPasswordModal = () => {
    this.setState({
      passwordModalVisible: true
    });
  };

  handleOkPasswordModal = () => {
    this.setState({
      passwordModalVisible: false
    });
  };

  handleCancelPasswordModal = () => {
    this.setState({
      passwordModalVisible: false
    });
  };

  handleInputChange(event) {
    const target = event.target;

    this.setState({
      [target.name]: target.value
    });
  }

  handleChangeEmail() {
    const errors = {};

    if (!this.state.email) {
      errors["email"] = this.props.t('Can not be blank');
    }

    this.setState({
      errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    this.props.userEmailUpdateRequest(
      this.props.user.id,
      this.props.user.first_name,
      this.props.user.last_name,
      this.props.user.username,
      this.state.email
    );
    this.setState({ lastFormSubmitted: "emailUpdate" });
  }

  handleChangePassword() {
    const errors = {};

    if (!this.state.currentPassword) {
      errors["currentPassword"] = this.props.t('Can not be blank');
    }
    if (!this.state.newPassword) {
      errors["newPassword"] = this.props.t('Can not be blank');
    }
    if (!this.state.repeatNewPassword) {
      errors["repeatNewPassword"] = this.props.t('Can not be blank');
    }
    if (this.state.newPassword !== this.state.repeatNewPassword) {
      errors["repeatNewPassword"] = this.props.t('Repeat the old password');
    }

    this.setState({
      errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    this.props.userPasswordUpdateRequest(
      this.props.user.id,
      this.state.currentPassword,
      this.state.newPassword,
      this.state.repeatNewPassword
    );
    this.setState({ lastFormSubmitted: "passwordChange" });
  }

  // Validates the picked image and sends it manually; returning false keeps
  // antd from uploading it on its own.
  handleBeforeUploadAvatar = file => {
    const { t } = this.props;

    if (!file.type || file.type.indexOf("image/") !== 0) {
      notification.error({
        duration: 3,
        placement: "bottomRight",
        message: t('Only image files are allowed')
      });
      return false;
    }

    if (file.size > MAX_AVATAR_SIZE_BYTES) {
      notification.error({
        duration: 3,
        placement: "bottomRight",
        message: t('The image must be smaller than 2MB')
      });
      return false;
    }

    this.props.uploadUserAvatar(this.props.user.id, file);
    return false;
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.closeModal && this.props.closeModal) {
      this.handleOkPasswordModal();
      this.handleOkMailModal();
    }

    // Keep the current page valid when the clients list is refreshed or shrinks.
    if (prevProps.clients !== this.props.clients) {
      const lastPage = getLastPage((this.props.clients || []).length, CLIENTS_PAGE_SIZE);
      if (this.state.clientsPage > lastPage) {
        this.setState({ clientsPage: lastPage });
      }
    }

    if (prevProps.uploadingAvatar && !this.props.uploadingAvatar) {
      if (this.props.avatarError) {
        notification.error({
          duration: 3,
          placement: "bottomRight",
          message: this.props.t('Could not update the profile photo')
        });
      } else {
        notification.success({
          duration: 2,
          placement: "bottomRight",
          message: this.props.t('Good!'),
          description: this.props.t('Changes successfully saved')
        });
      }
    }

    if (
      prevProps.fetching &&
      !this.props.fetching &&
      Object.keys(this.props.errors).length === 0
    ) {
      notification.success({
        duration: 2,
        placement: "bottomRight",
        message: this.props.t('Good!'),
        description: this.props.t('Changes successfully saved')
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <AccountLayout>
      <UserSettingsHolder>
        {this.props.user ? (
          <>
              <div className="profileHeader">
                <h1 className="pageTitle">{t('My profile')}</h1>
              </div>
              <Card className="settingsCard">
                <h3 className="sectionTitle">{t('Profile information')}</h3>
                <div className="profileInfo">
                  <div className="profileInfoFields">
                    {this.props.user.company ? (
                      <div className="fieldGroup">
                        <label className="fieldLabel">{t('Company')}</label>
                        <Input
                          readOnly
                          value={this.props.user.company.name}
                          suffix={this.props.user.company.is_verified ? <VerifiedCheck /> : null}
                        />
                      </div>
                    ) : null}
                    <div className="fieldGroup">
                      <label className="fieldLabel">{t('User')}</label>
                      <Input
                        readOnly
                        value={`${this.props.user.first_name} ${this.props.user.last_name}`}
                      />
                    </div>
                    <div className="fieldGroup">
                      <label className="fieldLabel">{t('Email address')}</label>
                      <Input
                        readOnly
                        addonBefore="@"
                        value={this.props.user.email}
                      />
                    </div>
                    <div className="profileActions">
                      <Button className="profileButton" onClick={this.showMailModal}>
                        {t('Change Mail')}
                      </Button>
                      <Button className="profileButton" onClick={this.showPasswordModal}>
                        {t('Change Password')}
                      </Button>
                    </div>
                  </div>
                  <div className="profilePhoto">
                    <label className="fieldLabel">{t('Profile photo')}</label>
                    <div className="profilePhotoWrapper">
                      {this.props.user.avatar ? (
                        <img
                          src={this.props.user.avatar}
                          className="profilePhotoImage"
                          alt=""
                        />
                      ) : (
                        <Avatar
                          icon="user"
                          size={200}
                          style={{ backgroundColor: Colors.primary }}
                        />
                      )}
                      <Upload
                        accept="image/*"
                        showUploadList={false}
                        beforeUpload={this.handleBeforeUploadAvatar}
                      >
                        <Button
                          className="profileButton profilePhotoButton"
                          size="small"
                          icon="swap"
                          title={t('Change profile photo')}
                          loading={this.props.uploadingAvatar}
                        />
                      </Upload>
                    </div>
                  </div>
                </div>
                {this.props.user.company ? (
                  <>
                    <hr className="sectionDivider" />
                    <h3 className="sectionTitle">{t('Agency data')}</h3>
                    <div className="agencyData">
                      <div className="fieldGroup">
                        <label className="fieldLabel">{t('Business name')}</label>
                        <Input
                          readOnly
                          value={this.props.user.company.billing_information_name || ""}
                        />
                      </div>
                      <div className="fieldGroup">
                        <label className="fieldLabel">{t('Tax ID')}</label>
                        <Input
                          readOnly
                          value={this.props.user.company.billing_information_tax_id || ""}
                        />
                      </div>
                      <div className="fieldGroup agencyDataAddress">
                        <label className="fieldLabel">{t('Address')}</label>
                        <Input
                          readOnly
                          value={this.props.user.company.address || ""}
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </Card>
              {this.isAgency() ? (
                <Card className="settingsCard">
                  <h3 className="sectionTitle">{t('Associated brands')}</h3>
                  <Table
                    className="brandsTable"
                    rowKey="id"
                    size="small"
                    pagination={false}
                    loading={this.props.fetchingClients}
                    dataSource={getPageItems(this.props.clients || [], this.state.clientsPage, CLIENTS_PAGE_SIZE)}
                    locale={{ emptyText: t('You have no associated clients yet') }}
                    columns={[
                      {
                        title: t('Client'),
                        dataIndex: "name",
                        width: 188,
                        render: name => <strong>{name}</strong>
                      },
                      {
                        title: t('Brands'),
                        dataIndex: "brands",
                        render: brands => (
                          <div className="brandBadges">
                            {(brands || []).map(brand => (
                              <span className="brandBadge" key={brand.id}>
                                {brand.name}
                              </span>
                            ))}
                          </div>
                        )
                      }
                    ]}
                  />
                  <ListPagination
                    className="brandsPagination"
                    total={(this.props.clients || []).length}
                    pageSize={CLIENTS_PAGE_SIZE}
                    current={this.state.clientsPage}
                    onChange={this.changeClientsPage}
                    labelKey="Showing {{shown}} of {{total}} clients"
                  />
                </Card>
              ) : null}
            <Modal
              className="modalSettings"
              visible={this.state.mailModalVisible}
              onOk={this.handleOkMailModal}
              onCancel={this.handleCancelMailModal}
              footer={null}
            >
              <div className="modalSettingsHeader">
                <h2>{t('Change Mail')}</h2>
              </div>
              <div className="modalSettingsContent">
                <div className="cardInfo">
                  <span className="cardInfoPrimary">Email</span> <br />{" "}
                  {this.props.user.email}
                </div>
                <Form.Item
                  validateStatus={!!this.state.errors["email"] && "error"}
                  help={this.state.errors["email"]}
                >
                  <Input
                    className="modalInput"
                    name="email"
                    autoComplete="username"
                    onChange={this.handleInputChange}
                    onPressEnter={() => this.handleChangeEmail()}
                    placeholder={t('New Mail')}
                    prefix={<Icon type="mail" className="inputIcon" />}
                  />
                </Form.Item>
                <div className="cardInfoError">
                  {this.props.errors &&
                  this.state.lastFormSubmitted === "emailUpdate"
                    ? this.props.errors
                    : null}
                </div>
                <div className="modalSettingsButtonContainer">
                  <Button
                    className="modalSettingsButton"
                    onClick={() => this.handleChangeEmail()}
                    loading={this.props.fetching}
                  >
                    {t('Change Mail')}
                  </Button>
                </div>
              </div>
            </Modal>
            <Modal
              className="modalSettings"
              visible={this.state.passwordModalVisible}
              onOk={this.handleOkPasswordModal}
              onCancel={this.handleCancelPasswordModal}
              footer={null}
            >
              <div className="modalSettingsHeader">
                <h2>{t('Change Password')}</h2>
              </div>
              <div className="modalSettingsContent">
                <Form.Item
                  validateStatus={
                    !!this.state.errors["currentPassword"] && "error"
                  }
                  help={this.state.errors["currentPassword"]}
                >
                  <Input
                    className="modalInput"
                    name="currentPassword"
                    autoComplete="current-password"
                    onChange={this.handleInputChange}
                    onPressEnter={() => this.handleChangePassword()}
                    placeholder={t('Current Password')}
                    type="password"
                    prefix={<Icon type="lock" className="inputIcon" />}
                  />
                </Form.Item>
                <Form.Item
                  validateStatus={!!this.state.errors["newPassword"] && "error"}
                  help={this.state.errors["newPassword"]}
                >
                  <Input
                    className="modalInput"
                    name="newPassword"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onPressEnter={() => this.handleChangePassword()}
                    placeholder={t('New Password')}
                    type="password"
                    prefix={<Icon type="lock" className="inputIcon" />}
                  />
                </Form.Item>
                <Form.Item
                  validateStatus={
                    !!this.state.errors["repeatNewPassword"] && "error"
                  }
                  help={this.state.errors["repeatNewPassword"]}
                >
                  <Input
                    className="modalInput"
                    name="repeatNewPassword"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onPressEnter={() => this.handleChangePassword()}
                    placeholder={t('Repeat New Password')}
                    type="password"
                    prefix={<Icon type="lock" className="inputIcon" />}
                  />
                </Form.Item>
                <div className="cardInfo">
                  {this.props.errors &&
                  this.state.lastFormSubmitted === "passwordChange"
                    ? this.props.errors
                    : null}
                </div>
                <div className="modalSettingsButtonContainer">
                  <Button
                    className="modalSettingsButton"
                    onClick={() => this.handleChangePassword()}
                    loading={this.props.fetching}
                  >
                    {t('Change Password')}
                  </Button>
                </div>
              </div>
            </Modal>
          </>
        ) : null}
      </UserSettingsHolder>
      </AccountLayout>
    );
  }
}
const Extended = withTranslation()(UserSettingsComponent);
Extended.static = UserSettingsComponent.static;

export default withRouter(Extended);
